import React from 'react';
import { Star, ArrowLeft, LinkedinLogo, FacebookLogo, Cigarette, CigaretteSlash, PawPrint, User, UsersThree, EnvelopeSimple, IdentificationCard, Coins, Wallet, MapPin, Flag, ArrowRight, HouseLine, Sparkle } from '@phosphor-icons/react';
import { ReviewsRatingSummary } from '../components/dashboard/ReviewCard';
import { PAGE_ROUTE } from '../lib/routes';
import { IdentityCard } from '../components/dashboard/IdentityCard';
import { cn, formatBudget, LIVING_MODE_DISPLAY, LivingModeValue, isFullyVerified, getStoredReviewsForSubject } from '../lib/utils';
interface TenantProfileProps {
  navigate: (page: string, context?: any) => void;
  context?: {
    slug?: string;
    viewerIsOwner?: boolean;
  };
}
const MOCK_PROFILES: Record<string, any> = {
  'olivia-p': {
    id: '1',
    slug: 'olivia-p',
    firstName: 'Olivia',
    lastName: 'P.',
    birthYear: 1995,
    occupation: 'Freelancer',
    city: 'București',
    budgetMin: 500,
    budgetMax: 650,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'cuplu',
    isSmoker: false,
    hasPets: true,
    petDetails: '1 pisică',
    profilePhoto: 'https://i.pravatar.cc/150?img=5',
    profileViews: 142,
    verifications: {
      email: true,
      identity: true,
      income: true
    },
    rating: 4.8,
    neighborhoods: 'Floreasca, Aviatorilor',
    moveInDate: 'Octombrie, 2026',
    contractDuration: '1 an',
    rooms: '3 cam',
    floor: 'Etaj 1-3',
    yearBuiltLabel: '> 1990',
    profileStatus: 'active',
    linkedinConnected: true,
    facebookConnected: true,
    amenities: ['Centrală termică', 'Parcare', 'Aer condiționat', 'Mobilat complet', 'Balcon / Terasă', 'Lift', 'Mașină de spălat vase'],
    bio: 'Bună, eu sunt Olivia. Lucrez de acasă ca freelancer și caut un apartament luminos, preferabil cu un spațiu pe care să-l pot amenaja ca birou. Suntem un cuplu liniștit și avem o pisică foarte educată. Ne-ar plăcea un proprietar comunicativ și deschis la o închiriere pe termen lung.',
    // Tenants only receive reviews from landlords (proprietari), not agents.
    reviews: [{
      id: 'r1',
      author: 'Vlad Constantin',
      authorRole: 'Proprietar',
      authorSlug: 'andrei-proprietar',
      rating: 5,
      date: 'Mai 2025',
      body: 'Olivia a fost o chiriașă model. Plăți la timp, comunicare excelentă, apartament impecabil la final de contract. Recomand cu încredere.',
      avatar: 'https://i.pravatar.cc/80?img=33'
    }],
    rentalHistory: [{
      id: 'h1',
      address: 'Apartament 2 cam, Floreasca',
      period: 'Ian 2023 – Apr 2025',
      durationLabel: '2 ani 3 luni',
      landlord: 'Vlad Constantin',
      completed: true
    }, {
      id: 'h2',
      address: 'Garsonieră, Tineretului',
      period: 'Sep 2021 – Dec 2022',
      durationLabel: '1 an 3 luni',
      landlord: 'Diana Popescu',
      completed: true
    }]
  },
  'andrei-popescu': {
    id: '2',
    slug: 'andrei-popescu',
    firstName: 'Andrei',
    lastName: 'P.',
    birthYear: 1996,
    occupation: 'Product Designer',
    city: 'București',
    budgetMin: 400,
    budgetMax: 550,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'singur',
    isSmoker: false,
    hasPets: false,
    petDetails: '',
    profilePhoto: 'https://i.pravatar.cc/150?img=11',
    profileViews: 142,
    verifications: {
      email: true,
      identity: true,
      income: false
    },
    rating: 4.6,
    neighborhoods: 'Cotroceni, Militari',
    moveInDate: 'Iunie, 2026',
    contractDuration: '2 ani',
    rooms: '2 cam',
    floor: 'Etaj 2-5',
    yearBuiltLabel: '> 2000',
    profileStatus: 'active',
    linkedinConnected: true,
    facebookConnected: false,
    amenities: ['Centrală termică', 'Mobilat complet', 'Aer condiționat', 'Balcon / Terasă', 'Aproape de metrou'],
    bio: 'Salut! Sunt Andrei, lucrez ca Product Designer. Caut un loc modern și curat, aproape de metrou. Sunt ordonat, nu fumez și plătesc mereu la timp.',
    reviews: [],
    rentalHistory: [{
      id: 'h1',
      address: 'Garsonieră, Crângași',
      period: 'Mar 2024 – Mar 2025',
      durationLabel: '1 an',
      landlord: 'Radu T.',
      completed: true
    }]
  },
  'maria-ionescu': {
    id: '3',
    slug: 'maria-ionescu',
    firstName: 'Maria',
    lastName: 'I.',
    birthYear: 1992,
    occupation: 'Marketing Manager',
    city: 'Cluj-Napoca',
    budgetMin: 600,
    budgetMax: 800,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'cuplu',
    isSmoker: false,
    hasPets: true,
    petDetails: '1 pisică',
    profilePhoto: 'https://i.pravatar.cc/150?img=9',
    profileViews: 89,
    verifications: {
      email: true,
      identity: false,
      income: false
    },
    rating: 4.9,
    neighborhoods: 'Centru, Andrei Mureșanu',
    moveInDate: 'August, 2026',
    contractDuration: '1 an',
    rooms: '3 cam',
    floor: 'Etaj 1-4',
    yearBuiltLabel: '> 1995',
    profileStatus: 'active',
    linkedinConnected: false,
    facebookConnected: false,
    amenities: ['Centrală termică', 'Parcare', 'Mobilat complet', 'Lift', 'Balcon / Terasă'],
    bio: 'Lucrez în marketing de 8 ani. Împreună cu partenerul meu, căutăm un apartament spațios pe termen lung. Avem o pisică foarte cuminte.',
    reviews: [{
      id: 'r1',
      author: 'Vlad Constantin',
      authorRole: 'Proprietar',
      authorSlug: 'andrei-proprietar',
      rating: 5,
      date: 'Decembrie 2024',
      body: 'Maria a fost o chiriașă foarte serioasă. Plăți la timp, comunicare clară, am rămas în relații bune și după ce s-a mutat.',
      avatar: 'https://i.pravatar.cc/80?img=15'
    }],
    rentalHistory: []
  }
};
const DEFAULT_SLUG = 'olivia-p';
/**
 * Demo-only helper: return the tenant's reviews mapped to the shared `Review`
 * shape used by ReviewCard. This keeps the tenant's own dashboard in sync
 * with what visitors see on their public profile.
 */
export function getDemoTenantReviewsForSlug(slug?: string): any[] {
  if (!slug) return [];
  const profile = MOCK_PROFILES[slug];
  if (!profile || !Array.isArray(profile.reviews)) return [];
  return profile.reviews.map((r: any) => ({
    id: r.id,
    reviewerName: r.author,
    reviewerRole: r.authorRole,
    reviewerSlug: r.authorSlug,
    reviewerVerified: true,
    avatar: r.avatar,
    rating: r.rating,
    date: r.date,
    body: r.body,
    periodLabel: '',
    categoryRatings: {},
    status: 'transactional' as const
  }));
}
export function TenantProfile({
  navigate,
  context
}: TenantProfileProps) {
  const slug = context?.slug || DEFAULT_SLUG;
  const profile = MOCK_PROFILES[slug] || MOCK_PROFILES[DEFAULT_SLUG];
  const viewerIsOwner = context?.viewerIsOwner === true;
  const isProfileInactive = profile.profileStatus === 'inactive';
  const fullyVerified = isFullyVerified(profile.verifications);
  const livingModeKey = profile.coupleStatus === 'singur' ? 'single' : profile.coupleStatus === 'cuplu' ? 'couple' : profile.coupleStatus === 'familie' ? 'family' : profile.coupleStatus === 'co-living' ? 'combo' : null;
  const livingModeDisplay = livingModeKey ? LIVING_MODE_DISPLAY[livingModeKey as LivingModeValue] : profile.coupleStatus;
  // Merge mock seed reviews with stored reviews submitted about this tenant.
  // Stored reviews are mapped to the inline shape this page renders against.
  const storedReviewsForTenant = getStoredReviewsForSubject(profile.slug).map(r => ({
    id: r.id,
    author: r.reviewerName,
    authorRole: r.reviewerRole,
    authorSlug: r.reviewerSlug,
    rating: Math.round(r.rating),
    date: r.date,
    body: r.body,
    avatar: r.reviewerAvatar || 'https://i.pravatar.cc/80?u=' + (r.reviewerSlug || r.id)
  }));
  const displayReviews = [...storedReviewsForTenant, ...(profile.reviews || [])];
  return <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pb-32 sm:pb-12" data-id="element-4300">
      {viewerIsOwner && <div className="mb-6 rounded-2xl bg-lime-5 border border-lime-4 p-4 flex items-center gap-3" data-id="element-4301">
          <div className="w-2 h-2 rounded-full bg-lime-1 shrink-0" data-id="element-4302" />
          <p className="text-sm text-light-1 flex-1 min-w-0" data-id="element-4303">
            <span className="font-semibold" data-id="element-4304">
              Aceasta e vederea publică a profilului tău.
            </span>{' '}
            <span className="text-light-3" data-id="element-4305">Așa te văd proprietarii.</span>
          </p>
          <button onClick={() => navigate(PAGE_ROUTE.DASHBOARD_PROFIL)} className="text-xs font-semibold text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-4306">
            Editează profilul
          </button>
        </div>}

      {isProfileInactive && !viewerIsOwner && <div className="mb-6 rounded-2xl bg-dark-2 border border-dark-4 p-4 flex items-start gap-3" data-id="element-4307">
          <div className="w-2 h-2 rounded-full bg-light-4 mt-1.5 shrink-0" data-id="element-4308" />
          <p className="text-sm text-light-2 flex-1" data-id="element-4309">
            <span className="font-semibold text-light-1" data-id="element-4310">
              {profile.firstName} nu mai caută momentan.
            </span>{' '}
            Anunțul a fost pus pe pauză.
          </p>
          <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-xs font-semibold text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-4311">
            Vezi profile similare
          </button>
        </div>}

      {!viewerIsOwner && <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors mb-6 inline-flex items-center gap-1.5 font-medium" data-id="element-4312">
          <ArrowLeft size={16} weight="bold" data-id="element-4313" />
          Înapoi la Marketplace
        </button>}

      {/* UNIFIED IDENTITY CARD */}
      <div className="mb-8" data-id="element-4314">
        <IdentityCard mode="public" data={{
        firstName: profile.firstName,
        lastName: profile.lastName,
        avatar: profile.profilePhoto || null,
        occupation: profile.occupation,
        bio: profile.bio || null,
        memberSinceYear: 2024,
        rating: profile.rating || 0,
        reviewCount: profile.reviews?.length || 0,
        verifications: profile.verifications || {
          email: false,
          identity: false,
          income: false
        },
        isSmoker: profile.isSmoker || false,
        hasPets: profile.hasPets || false,
        pets: profile.hasPets ? profile.petDetails : null,
        livingMode: livingModeDisplay as string,
        linkedinConnected: profile.linkedinConnected ?? true,
        linkedinUrl: profile.linkedinConnected !== false ? 'https://linkedin.com' : null,
        facebookConnected: profile.facebookConnected ?? true,
        facebookUrl: profile.facebookConnected !== false ? 'https://facebook.com' : null,
        activeAnunt: {
          hasActive: !isProfileInactive,
          budgetMaxEur: profile.budgetMax,
          neighborhoods: profile.neighborhoods,
          moveInDate: profile.moveInDate
        }
      }} isProfileInactive={isProfileInactive} onNavigateToAnunt={() => navigate(PAGE_ROUTE.TENANT_ANUNT, {
        slug: profile.slug
      })} data-id="element-4315" />
      </div>

      {/* REVIEWS CARD */}
      <div className="mb-8" data-id="element-4316">
        <div className="flex items-center justify-between mb-4" data-id="element-4317">
          <h2 className="text-lg font-semibold text-light-1" data-id="element-4318">Recenzii</h2>
          <ReviewsRatingSummary reviews={displayReviews} data-id="element-4319" />
        </div>
        {displayReviews.length > 0 ? <div className="space-y-4" data-id="element-4320">
            {displayReviews.map((review: any) => {
          const reviewerSlug = review.authorSlug;
          const nameClickable = !!reviewerSlug;
          return <div key={review.id} className="bg-dark-2 border border-dark-4 rounded-2xl p-6" data-id="element-4321">
                  <div className="flex items-start justify-between mb-4 gap-4" data-id="element-4322">
                    <div className="flex items-center gap-3 min-w-0" data-id="element-4323">
                      <img src={review.avatar} alt={review.author} className="w-10 h-10 rounded-full object-cover shrink-0" data-id="element-4324" />
                      <div className="min-w-0" data-id="element-4325">
                        <div className="font-medium text-light-1 flex items-center gap-1.5 min-w-0" data-id="element-4326">
                          {nameClickable ? <button type="button" onClick={() => navigate(PAGE_ROUTE.LANDLORD_PROFILE, {
                      slug: reviewerSlug
                    })} className="truncate hover:underline underline-offset-4 cursor-pointer text-left" data-id="element-4327">
                              {review.author}
                            </button> : <span className="truncate" data-id="element-4328">{review.author}</span>}
                        </div>
                        <div className="text-xs text-light-3 truncate" data-id="element-4329">
                          {review.authorRole}
                        </div>
                      </div>
                    </div>
                    <div className="text-right shrink-0" data-id="element-4330">
                      <div className="flex items-center gap-1 text-lime-1 mb-1" data-id="element-4331">
                        {Array.from({
                    length: Math.max(0, Math.min(5, Math.round(review.rating || 0)))
                  }).map((_, i) => <Star key={i} size={14} weight="fill" data-id="element-4332" />)}
                      </div>
                      <div className="text-xs text-light-4" data-id="element-4333">{review.date}</div>
                    </div>
                  </div>
                  <p className="text-sm text-light-2 leading-relaxed" data-id="element-4334">
                    "{review.body}"
                  </p>
                </div>;
        })}
          </div> : <div className="bg-dark-2 border border-dark-4 border-dashed rounded-2xl p-8 text-center" data-id="element-4335">
            <Star size={32} weight="duotone" className="text-light-4 mx-auto mb-3" data-id="element-4336" />
            <p className="text-sm text-light-3" data-id="element-4337">
              Recenziile vor apărea aici după primele închirieri.
            </p>
          </div>}
      </div>

      {/* RENTAL HISTORY CARD */}
      <div data-id="element-4338">
        <h2 className="text-lg font-semibold text-light-1 mb-4" data-id="element-4339">
          Istoric închirieri
        </h2>
        {profile.rentalHistory && profile.rentalHistory.length > 0 ? <div className="bg-dark-2 border border-dark-4 rounded-2xl overflow-hidden" data-id="element-4340">
            <div className="divide-y divide-dark-4" data-id="element-4341">
              {profile.rentalHistory.map((history: any) => <div key={history.id} className="p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-4342">
                  <div className="flex items-start gap-4" data-id="element-4343">
                    <div className="w-10 h-10 rounded-full bg-dark-3 flex items-center justify-center shrink-0" data-id="element-4344">
                      <HouseLine size={20} className="text-light-3" data-id="element-4345" />
                    </div>
                    <div data-id="element-4346">
                      <div className="font-medium text-light-1 mb-1" data-id="element-4347">
                        {history.address}
                      </div>
                      <div className="text-sm text-light-3 mb-1" data-id="element-4348">
                        {history.period}{' '}
                        <span className="text-light-4 mx-1" data-id="element-4349">·</span>{' '}
                        {history.durationLabel}
                      </div>
                      <div className="text-xs text-light-4" data-id="element-4350">
                        Proprietar: {history.landlord}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div> : <div className="bg-dark-2 border border-dark-4 border-dashed rounded-2xl p-8 text-center" data-id="element-4351">
            <p className="text-sm text-light-3" data-id="element-4352">
              🏠 Istoricul va apărea aici după prima închiriere confirmată.
            </p>
          </div>}
      </div>
    </div>;
}